export function ContactSection() {
  return (
    <>
      <div className="flex flex-wrap gap-2.5 mb-8">
        <a
          href="mailto:jens@fermi.no"
          className="border border-white/15 px-3.5 py-1.5 text-sm tracking-wide text-white/60 hover:text-white hover:border-white/30 transition-colors duration-200"
        >
          kontakt
        </a>
        <a
          href="tel:+4741669993"
          className="border border-white/15 px-3.5 py-1.5 text-sm tracking-wide text-white/60 hover:text-white hover:border-white/30 transition-colors duration-200"
        >
          +47 416 69 993
        </a>
      </div>

      <footer className="flex flex-col gap-y-1 text-xs text-white/40">
        <span>931 547 445</span>
        <span>©{new Date().getFullYear()} fermi solutions</span>
      </footer>
    </>
  );
}
